import { CellPlugin } from '@react-page/editor';
import ThreeRiversSearch, {
    BILL_NUMBER_LABEL, BILL_NUMBER_PLACEHOLDER, SEARCH_HELP_TEXT, SEARCH_LABEL, RESET_LABEL, MARGIN, PADDING,
    RESET_BUTTON_BACKGROUND_COLOR, RESET_BUTTON_FONT_COLOR, RESET_BUTTON_FONT_SIZE, RESET_BUTTON_FONT_STYLE, RESET_BUTTON_FONT_WEIGHT,
    RESET_BUTTON_BORDER_COLOR, SUBMIT_BUTTON_BACKGROUND_COLOR, SUBMIT_BUTTON_FONT_COLOR, SUBMIT_BUTTON_FONT_SIZE, SUBMIT_BUTTON_FONT_STYLE,
    SUBMIT_BUTTON_FONT_WEIGHT, BILL_NUMBER_WILDCARD
} from './components/ThreeRiversSearch';

type Data = {
    billNumber: string,
    billNumberPlaceholder: string,
    searchHelpText: string,
    search: string,
    reset: string,
    margin: string,
    padding: string,
    resetButtonBackgroundColor: string,
    resetButtonFontColor: string,
    resetButtonFontSize: string,
    resetButtonFontStyle: string,
    resetButtonFontWeight: string,
    resetButtonBorderColor: string,
    submitButtonBackgroundColor: string,
    submitButtonFontColor: string,
    submitButtonFontSize: string,
    submitButtonFontStyle: string,
    submitButtonFontWeight: string,
    billNumberWildcard: boolean,
}

const ThreeRiversSearchPlugin: CellPlugin<Data> = {
    Renderer: ({ data }) => (
        <ThreeRiversSearch
            billNumberLabel={data.billNumber}
            billNumberPlaceholder={data.billNumberPlaceholder}
            searchHelpText={data.searchHelpText}
            searchLabel={data.search}
            resetLabel={data.reset}
            margin={data.margin}
            padding={data.padding}
            resetButtonBackgroundColor={data.resetButtonBackgroundColor}
            resetButtonFontColor={data.resetButtonFontColor}
            resetButtonFontSize={data.resetButtonFontSize}
            resetButtonFontStyle={data.resetButtonFontStyle}
            resetButtonFontWeight={data.resetButtonFontWeight}
            resetButtonBorderColor={data.resetButtonBorderColor}
            submitButtonBackgroundColor={data.submitButtonBackgroundColor}
            submitButtonFontColor={data.submitButtonFontColor}
            submitButtonFontSize={data.submitButtonFontSize}
            submitButtonFontStyle={data.submitButtonFontStyle}
            submitButtonFontWeight={data.submitButtonFontWeight}
            billNumberWildcard={data.billNumberWildcard}
        />
    ),
    id: 'threeRiversSearchPlugin',
    title: 'Three Rivers Search',
    description: 'Search Three Rivers Planning & Development District bills by Bill Number',
    version: 1,
    controls: [
        {
            title: 'Search Options',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        billNumberWildcard: {
                            type: 'boolean',
                            title: 'Bill Number - partial match (LIKE) instead of exact',
                            default: BILL_NUMBER_WILDCARD,
                        },
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Labels',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        billNumber: {
                            type: 'string',
                            default: BILL_NUMBER_LABEL,
                        },
                        billNumberPlaceholder: {
                            type: 'string',
                            default: BILL_NUMBER_PLACEHOLDER,
                        },
                        searchHelpText: {
                            type: 'string',
                            default: SEARCH_HELP_TEXT,
                        },
                        search: {
                            type: 'string',
                            default: SEARCH_LABEL,
                        },
                        reset: {
                            type: 'string',
                            default: RESET_LABEL,
                        },
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Styles',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        margin: {
                            type: 'string',
                            default: MARGIN,
                        },
                        padding: {
                            type: 'string',
                            default: PADDING,
                        },
                        resetButtonBackgroundColor: {
                            type: 'string',
                            default: RESET_BUTTON_BACKGROUND_COLOR,
                        },
                        resetButtonFontColor: {
                            type: 'string',
                            default: RESET_BUTTON_FONT_COLOR,
                        },
                        resetButtonFontSize: {
                            type: 'string',
                            default: RESET_BUTTON_FONT_SIZE,
                        },
                        resetButtonFontStyle: {
                            type: 'string',
                            default: RESET_BUTTON_FONT_STYLE,
                        },
                        resetButtonFontWeight: {
                            type: 'string',
                            default: RESET_BUTTON_FONT_WEIGHT,
                        },
                        resetButtonBorderColor: {
                            type: 'string',
                            default: RESET_BUTTON_BORDER_COLOR,
                        },
                        submitButtonBackgroundColor: {
                            type: 'string',
                            default: SUBMIT_BUTTON_BACKGROUND_COLOR,
                        },
                        submitButtonFontColor: {
                            type: 'string',
                            default: SUBMIT_BUTTON_FONT_COLOR,
                        },
                        submitButtonFontSize: {
                            type: 'string',
                            default: SUBMIT_BUTTON_FONT_SIZE,
                        },
                        submitButtonFontStyle: {
                            type: 'string',
                            default: SUBMIT_BUTTON_FONT_STYLE,
                        },
                        submitButtonFontWeight: {
                            type: 'string',
                            default: SUBMIT_BUTTON_FONT_WEIGHT,
                        },
                    },
                    required: [],
                },
            },
        },
    ],
};

export default ThreeRiversSearchPlugin;
